import React, { useState, useRef, useEffect } from 'react';
import { T, STATUS, STATUS_ORDER, initials, avatarColor } from '../theme';

// Baş harf avatarı (yuvarlak)
export function Avatar({ name, size = 26 }) {
  return (
    <span title={name} style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: size, height: size, borderRadius: '50%', background: avatarColor(name),
      color: '#fff', fontSize: size * 0.4, fontWeight: 700, flexShrink: 0,
    }}>{initials(name)}</span>
  );
}

export function AvatarStack({ people = [], size = 26 }) {
  if (!people.length) return <span style={{ color: T.dim, fontSize: 12 }}>—</span>;
  return (
    <span style={{ display: 'inline-flex' }}>
      {people.slice(0, 4).map((p, i) => (
        <span key={p.id || i} style={{ marginLeft: i ? -8 : 0, border: `2px solid ${T.card}`, borderRadius: '50%' }}>
          <Avatar name={p.name} size={size} />
        </span>
      ))}
      {people.length > 4 && <span style={{ marginLeft: -8, ...pillStyle(size), background: T.border2 }}>+{people.length - 4}</span>}
    </span>
  );
}
const pillStyle = (size) => ({
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  width: size, height: size, borderRadius: '50%', color: '#fff', fontSize: size * 0.36, fontWeight: 700,
});

// Status rozeti + inline dropdown
export function StatusBadge({ value, onChange, editable = true }) {
  const s = STATUS[value] || { label: value, color: T.muted };
  if (!editable) {
    return <span style={badge(s.color)}>{s.label}</span>;
  }
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)}
      style={{ ...badge(s.color), border: `1px solid ${s.color}55`, cursor: 'pointer', appearance: 'none', paddingRight: 22 }}>
      {STATUS_ORDER.map(k => <option key={k} value={k} style={{ background: T.panel, color: T.text }}>{STATUS[k].label}</option>)}
    </select>
  );
}
const badge = (color) => ({
  background: color + '22', color, fontSize: 12, fontWeight: 600,
  padding: '4px 10px', borderRadius: 6, outline: 'none',
});

// Tip chip'leri
export function TypeChips({ types = [] }) {
  if (!types.length) return <span style={{ color: T.dim, fontSize: 12 }}>—</span>;
  return (
    <span style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
      {types.map(t => (
        <span key={t.id} style={{ background: T.border, color: T.text2, fontSize: 11, padding: '2px 8px', borderRadius: 20 }}>{t.name}</span>
      ))}
    </span>
  );
}

// "Tamamlananları göster" kutucuğu
export function DoneToggle({ checked, onChange }) {
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12, color: T.muted, textTransform: 'none', letterSpacing: 0 }}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} style={{ accentColor: T.blue }} />
      Tamamlananları göster
    </label>
  );
}

// Çoklu seçim dropdown (assignee / marka / type)
export function MultiSelect({ label, options, value = [], onChange, single = false, placeholder = 'Seç' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h); return () => document.removeEventListener('mousedown', h);
  }, []);
  const sel = value.map(Number);
  const toggle = (id) => {
    if (single) { onChange([id]); setOpen(false); return; }
    onChange(sel.includes(id) ? sel.filter(x => x !== id) : [...sel, id]);
  };
  const labels = options.filter(o => sel.includes(o.id)).map(o => o.label);
  return (
    <div ref={ref} style={{ position: 'relative', minWidth: 150 }}>
      {label && <div style={{ fontSize: 11, color: T.muted, marginBottom: 4 }}>{label}</div>}
      <button type="button" onClick={() => setOpen(o => !o)} style={{
        width: '100%', textAlign: 'left', padding: '7px 10px', background: T.panel,
        border: `1px solid ${T.border2}`, borderRadius: 6, color: labels.length ? T.text : T.dim,
        fontSize: 13, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', gap: 6,
      }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {labels.length ? labels.join(', ') : placeholder}
        </span>
        <span style={{ color: T.dim }}>▾</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute', zIndex: 50, top: '100%', left: 0, right: 0, marginTop: 4,
          background: T.panel, border: `1px solid ${T.border2}`, borderRadius: 8, maxHeight: 240,
          overflowY: 'auto', boxShadow: '0 8px 24px rgba(0,0,0,.4)',
        }}>
          {!single && (
            <div onClick={() => onChange([])} style={{ padding: '8px 10px', fontSize: 12, color: T.muted, cursor: 'pointer', borderBottom: `1px solid ${T.border}` }}>Temizle</div>
          )}
          {options.map(o => {
            const on = sel.includes(o.id);
            return (
              <label key={o.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', cursor: 'pointer', background: on ? T.blue + '18' : 'transparent' }}>
                {!single && <input type="checkbox" checked={on} readOnly style={{ accentColor: T.blue }} />}
                <span style={{ color: T.text, fontSize: 13 }} onClick={() => toggle(o.id)}>{o.label}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}
